// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"40":"debug","154":"customers","594":"about","766":"statistics","983":"products"}[chunkId] + "." + {"40":"20487d2a","154":"783c10e4","594":"2e1b7b54","766":"2adac452","983":"7413bb00"}[chunkId] + ".js";
};